import { useCallback } from 'react';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from './useGetMixpanelProps';
import { DocumentEventProps } from 'models/MixpanelEvents';
import { useTranslation } from 'react-i18next';
import utils from 'utils';

type UseMixpanelDocumentEventsProps = {
  documentName: string;
  dataRoomName?: string;
};

const useMixpanelDocumentEvents = ({
  documentName,
  dataRoomName,
}: UseMixpanelDocumentEventsProps) => {
  const getMixpanelProps = useGetMixpanelProps();

  const { t } = useTranslation();

  const getDocumentMixpanelProps = useCallback(
    (time: number) => {
      const { type, count } = utils.timeSpentInSecondsHumanize(time || 0, true);

      return getMixpanelProps({
        documentName,
        timespent: t(time ? `timeSpentInSecondsHumanizeLong.${type}` : 'na', {
          count,
        }),
        ...(time && { timespentInSeconds: time }),
        ...(dataRoomName && { dataRoom: dataRoomName }),
      }) as DocumentEventProps;
    },
    [documentName, dataRoomName, getMixpanelProps, t],
  );

  const onDocumentViewed = useCallback(
    (time: number) =>
      mixpanelService.documentViewed(getDocumentMixpanelProps(time)),
    [getDocumentMixpanelProps],
  );

  return { onDocumentViewed };
};

export default useMixpanelDocumentEvents;
